<template>
    <v-card shaped class="mx-sm-4 my-sm-4 pa-4">
        <v-row>
            <v-col cols="12"
                ><v-toolbar
                    flat
                    color="#1d2735"
                    dark
                    style="border-radius: 5px"
                >
                    <v-icon class="white--text" style="font-size: 45px"
                        >mdi-account-supervisor-circle</v-icon
                    >
                    <v-toolbar-title>
                        <h3>
                            {{ $route.query.id != null ? "Editar" : "Crear" }}
                            potencial
                            {{
                                $route.query.id != null
                                    ? "N°" + $route.query.id
                                    : ""
                            }}
                        </h3></v-toolbar-title
                    >
                </v-toolbar>

                <v-tabs :scrollable="false" value="tab">
                    <v-tab>Datos</v-tab>
                    <v-tab-item>
                        <div
                            style="
                                padding-top: 1rem;
                                padding-bottom: 1rem;
                                display: flex;
                                justify-content: space-between;
                            "
                        >
                            <div>
                                <v-btn
                                    @click="dialog = true"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    >Buscar cliente</v-btn
                                >
                            </div>
                            <div>
                                <v-tooltip right style="margin-bottom: 5px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            fab
                                            to="lista-peticiones"
                                            :loading="isloading"
                                            :disabled="isloading"
                                            color="blue"
                                            class="mt-4 mx-3"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon class="white--text"
                                                >mdi-arrow-left-bold-outline</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>Volver</span>
                                </v-tooltip>
                                <v-btn
                                    v-if="!peticion.id"
                                    @click="savePeticion()"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    >Guardar</v-btn
                                >

                                <v-btn
                                    v-if="peticion.id"
                                    @click="savePeticion(peticion.id)"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    >Actualizar</v-btn
                                >
                            </div>
                        </div>
                        <v-row justify="end">
                            <v-col cols="12" md="3">
                                <v-btn-toggle
                                    color="primary"
                                    shaped
                                    v-model="peticion.incidencia"
                                    background-color="white"
                                >
                                    <v-btn text> Presupuesto </v-btn>
                                    <v-btn text> Incidencia </v-btn>
                                </v-btn-toggle>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-autocomplete
                                    v-model="peticion.id_estado_potencial"
                                    :items="estados_potencial"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Estado"
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-text-field
                                    readonly
                                    :value="
                                        peticion.created_at == null
                                            ? peticion.fecha_alta
                                            : peticion.created_at
                                              | format_date_time
                                    "
                                    label="Fecha de alta"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-form ref="form" id="form" class="mt-3">
                            <DatosClientes
                                v-model="peticion.cliente"
                                :agentes="agentes"
                                :hide-fecha="true"
                            >
                                <v-col cols="12" md="7">
                                    <v-autocomplete
                                        outlined
                                        v-model="peticion.interes"
                                        :items="productos"
                                        item-text="titulo"
                                        item-value="id"
                                        label="Producto"
                                        :rules="required_val"
                                    >
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="7">
                                    <v-autocomplete
                                        :readonly="
                                            (rol == 4 || rol == 5) &
                                            (peticion.id != null)
                                        "
                                        outlined
                                        v-model="peticion.conocido"
                                        :items="conocido"
                                        item-text="name"
                                        item-value="id"
                                        label="¿Cómo nos ha conocido?"
                                    >
                                    </v-autocomplete>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="7"
                                    v-if="rol != 4 && rol != 5"
                                >
                                    <v-autocomplete
                                        outlined
                                        v-model="peticion.id_agente"
                                        :items="agentes"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Agente"
                                    >
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="7">
                                    <v-textarea
                                        rows="3"
                                        auto-grow
                                        outlined
                                        :label="'Observaciones'"
                                        v-model="peticion.observaciones"
                                    >
                                    </v-textarea>
                                </v-col>
                            </DatosClientes>
                        </v-form>
                    </v-tab-item>
                    <template v-if="peticion.id != null">
                        <v-tab>Archivos</v-tab>
                        <v-tab-item>
                            <listaArchivos
                                v-on:delete_archivo="deleteArchivo"
                                :items="peticion.archivo"
                                @subir_file="subirArchivo"
                                @subir_file_64="subirArchivo64"
                            ></listaArchivos>
                        </v-tab-item>
                        <v-tab>Dibujar</v-tab>
                        <v-tab-item>
                            <dibujar @save="subirArchivo64"> </dibujar>
                        </v-tab-item>
                        <v-tab>Seguimiento</v-tab>
                        <v-tab-item>
                            <tab-seguimiento
                                :id="peticion.id_cliente"
                            ></tab-seguimiento>
                        </v-tab-item>
                        <v-tab>Presupuestos</v-tab>
                        <v-tab-item>
                            <tab-presupuestos
                                :presupuestos="peticion.cliente.presupuestos"
                            ></tab-presupuestos>
                        </v-tab-item>
                        <v-tab>Historial</v-tab>
                        <v-tab-item>
                            <historial-estado-cliente
                                :id="peticion.id_cliente"
                            ></historial-estado-cliente>
                        </v-tab-item>
                        <v-tab>Facturas</v-tab>
                        <v-tab-item>
                            <tab-facturas
                                :facturas="peticion.cliente.facturas"
                            ></tab-facturas>
                        </v-tab-item>
                        <v-tab>Órdenes</v-tab>
                        <v-tab-item>
                            <tab-ordenes
                                :ordenes="peticion.cliente.ordenes"
                            ></tab-ordenes>
                        </v-tab-item>
                        <v-tab>Ubicación</v-tab>
                        <v-tab-item>
                            <v-row justify="center">
                                <v-col cols="10" md="6">
                                    <h4>Ubicación</h4>
                                </v-col>
                            </v-row>
                            <template v-if="peticion.cliente.latitud">
                                <v-row justify="center">
                                    <v-col cols="10" md="6">
                                        <v-text-field
                                            outlined
                                            readonly
                                            v-model="peticion.cliente.latitud"
                                            label="Latitud"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row justify="center">
                                    <v-col cols="10" md="6">
                                        <v-text-field
                                            outlined
                                            readonly
                                            v-model="peticion.cliente.longitud"
                                            label="Longitud"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-else>
                                <v-row justify="center">
                                    <v-col cols="10" md="6">
                                        <v-text-field
                                            outlined
                                            readonly
                                            v-model="
                                                peticion.cliente.direccion.lat
                                            "
                                            label="Latitud"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row justify="center">
                                    <v-col cols="10" md="6">
                                        <v-text-field
                                            outlined
                                            readonly
                                            v-model="
                                                peticion.cliente.direccion.lon
                                            "
                                            label="Longitud"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </template>
                            <v-row justify="center">
                                <v-col cols="10" md="6">
                                    <v-btn
                                        @click="navigate"
                                        :disabled="isloading"
                                        color="primary"
                                        class="white--text"
                                        >Abrir en Google Maps</v-btn
                                    >
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col cols="10" md="6">
                                    <v-btn
                                        @click="getLocation"
                                        :disabled="isloading"
                                        color="primary"
                                        class="white--text"
                                        >Conseguir ubicación actual</v-btn
                                    >
                                </v-col>
                            </v-row>
                        </v-tab-item>
                    </template>
                </v-tabs>
                <v-row style="margin-top: 2rem">
                    <v-col cols="12">
                        <router-link to="lista-peticiones">
                            <v-btn color="red" class="white--text mr-2">
                                Cancelar
                            </v-btn>
                        </router-link>
                        <v-btn
                            v-if="!peticion.id"
                            @click="savePeticion()"
                            :disabled="isloading"
                            color="success"
                            class="white--text mr-2"
                            >Guardar</v-btn
                        >

                        <v-btn
                            v-if="peticion.id"
                            @click="savePeticion(peticion.id)"
                            :disabled="isloading"
                            color="success"
                            class="white--text mr-2"
                            >Actualizar</v-btn
                        >
                        <router-link
                            :to="`guardar-presupuesto-potencial?cliente=${peticion.cliente.id}`"
                        >
                            <v-btn
                                v-if="peticion.id"
                                :disabled="isloading"
                                color="primary"
                                class="white--text mr-2"
                                >Generar presupuesto</v-btn
                            >
                        </router-link>

                        <v-btn
                            v-if="peticion.id"
                            @click="delete_dialog = true"
                            :disabled="isloading"
                            color="red"
                            class="white--text"
                            >Eliminar</v-btn
                        >
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <DialogMail
            v-model="dialog_mail"
            :productos="productos"
            :id_cliente="peticion.id_cliente"
            :id_producto="peticion.interes"
        ></DialogMail>
        <SearchClienteDialog
            @selected="seleccionarCliente"
            v-model="dialog"
        ></SearchClienteDialog>
        <DeleteDialog
            @delete="deletePeticion"
            v-model="delete_dialog"
        ></DeleteDialog>
    </v-card>
</template>
<script>
import SearchClienteDialog from "./SearchClienteDialog.vue";

import Dibujar from "../../presupuesto/componentes/Dibujar.vue";
import listaArchivos from "../../../components/general/listaArchivos.vue";
import HistorialEstadoCliente from "../../clientes/componentes/HistorialEstadoCliente.vue";
import TabSeguimiento from "../../clientes/componentes/TabSeguimiento.vue";
import TabPresupuestos from "../../clientes/componentes/TabPresupuestos.vue";
import TabFacturas from "../../clientes/componentes/TabFacturas.vue";
import TabOrdenes from "../../clientes/componentes/TabOrdenes.vue";
import OrdenTrabajoDialogVue from "../../clientes/componentes/OrdenTrabajoDialog.vue";
import DialogMail from "../../clientes/componentes/DialogMail.vue";
import DatosClientes from "../../clientes/componentes/DatosClientes.vue";
import DeleteDialog from "../../../components/general/dialogs/DeleteDialog.vue";
export default {
    components: {
        SearchClienteDialog,
        Dibujar,
        listaArchivos,
        HistorialEstadoCliente,
        TabSeguimiento,
        TabPresupuestos,
        TabFacturas,
        TabOrdenes,
        OrdenTrabajoDialogVue,
        DialogMail,
        DatosClientes,
        DeleteDialog,
    },
    data() {
        return {
            delete_dialog: false,
            rol: null,
            dialog_mail: false,
            tab: 0,
            dialog: false,
            required_val: [(v) => !!v || "El campo es requerido"],
            peticion_cliente: null,
            existente: 1,
            conocido: [],
            productos: [],
            agentes: [],
            estados_potencial: [],

            peticion: {
                id_cliente: null,
                id_agente: null,
                conocido: null,
                incidencia: 0,
                interes: null,
                fecha_alta: new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000
                ).toISOString(),
                cliente: {
                    misma_direccion: 1,
                    rol: this.$route.meta.rol,
                    id: null,
                    cif: null,
                    id_estado_potencial: 1,
                    direccion: {
                        id: null,
                        direccion: "",
                        codigo_postal: "",
                        id_provincia: 0,
                        ciudad: "",
                    },
                    direccion_instalacion: {
                        id: null,
                        direccion: "",
                        codigo_postal: "",
                        id_provincia: 0,
                        ciudad: "",
                    },
                    productos: [],
                    id_grupo: null,
                    razon_social: "",
                    nombre_comercial: "",
                    grupo: false,
                    grupos: [],
                    metodos_pago: [],
                    observaciones: "",
                    latitud: null,
                    longitud: null,
                    fecha_alta: new Date(
                        Date.now() - new Date().getTimezoneOffset() * 60000
                    ).toISOString(),
                    id_estado: 1,
                    agentes: [],
                    contactos: [],
                    id_tipologia: -1,
                    id_sector1: 0,
                    id_sector2: 0,
                    conocido: null,
                    interes: null,

                    cuenta: "",
                },
                id_estado_potencial: 1,
            },
        };
    },
    created() {
        this.rol = localStorage.getItem("role");
        this.getConocidos();
        this.getProductosInteres();
        this.getAgentes();
        this.getEstadosPotencial();
        if (this.$route.query.id) {
            this.getPeticion(this.$route.query.id);
        } else {
            if (this.$route.query.incidencia != null) {
                this.peticion.incidencia = parseInt(
                    this.$route.query.incidencia
                );
            }
            if (this.$route.query.cliente != null) {
                this.getcliente(this.$route.query.cliente);
            }
        }
    },
    methods: {
        subirArchivo(archivo) {
            archivo.append("id", this.peticion.id_cliente);
            axios.post(`api/save-archivo-cliente`, archivo).then((res) => {
                this.cliente.archivo = res.data;
            });
        },

        deleteArchivo(archivo) {
            axios.get(`api/deletearchivo/${archivo.id}`).then(
                (res) => {
                    this.peticion.archivo = res.data;
                },
                (res) => {
                    this.$toast.error("Error al eliminar el archivo");
                }
            );
        },
        subirArchivo64(data) {
            //console.log(extension);
            let me = this;
            axios
                .post(`api/peticiones/${this.peticion.id}/file`, {
                    id: this.peticion.id_cliente,
                    archivo: data.data,
                    nombre: data.nombre,
                    extension: data.extension,
                })
                .then((res) => {
                    me.peticion.archivo = res.data;
                    this.$toast.sucs("Archivo guardado con éxito");
                });
        },
        success(pos) {
            const crd = pos.coords;
            this.peticion.cliente.longitud = crd.longitude;
            this.peticion.cliente.latitud = crd.latitude;
        },
        error(err) {
            console.warn(`ERROR(${err.code}): ${err.message}`);
        },
        getLocation() {
            navigator.geolocation.getCurrentPosition(this.success, this.error, {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0,
            });
        },
        navigate() {
            let lat = this.peticion.cliente.latitud;
            let lng = this.peticion.cliente.longitud;
            if (lat == null) {
                lat = this.peticion.cliente.direccion.lat;
                lng = this.peticion.cliente.direccion.lon;
            }
            // If it's an iPhone..
            if (
                navigator.platform.indexOf("iPhone") !== -1 ||
                navigator.platform.indexOf("iPod") !== -1
            ) {
                function iOSversion() {
                    if (/iP(hone|od|ad)/.test(navigator.platform)) {
                        // supports iOS 2.0 and later
                        var v = navigator.appVersion.match(
                            /OS (\d+)_(\d+)_?(\d+)?/
                        );
                        return [
                            parseInt(v[1], 10),
                            parseInt(v[2], 10),
                            parseInt(v[3] || 0, 10),
                        ];
                    }
                }
                var ver = iOSversion() || [0];

                var protocol = "http://";
                if (ver[0] >= 6) {
                    protocol = "maps://";
                }
                window.location =
                    protocol +
                    "maps.apple.com/maps?daddr=" +
                    lat +
                    "," +
                    lng +
                    "&amp;ll=";
            } else {
                window.open(
                    "http://maps.google.com?daddr=" +
                        lat +
                        "," +
                        lng +
                        "&amp;ll="
                );
            }
        },
        deletePeticion() {
            axios.delete(`api/peticiones/${this.peticion.id}`).then(
                (res) => {
                    this.$toast.sucs("Potencial eliminado con éxito");
                    this.$router.push("lista-peticiones");
                },
                (err) => {
                    this.$custom_error("Error eliminando el potencial");
                }
            );
        },
        getEstadosPotencial() {
            axios.get(`api/get-estados-potencial`).then(
                (res) => {
                    this.estados_potencial = res.data;
                },
                (res) => {}
            );
        },
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.agentes = res.data.Agentes;
                },
                (res) => {}
            );
        },
        seleccionarCliente(cliente) {
            if (cliente == null) return;
            this.peticion.id_cliente = cliente.id;
            this.peticion.cliente = cliente;
            this.peticion.cliente.cuenta = cliente.cuenta_contable.numero;
            if (this.peticion.cliente.direccion_instalacion == null) {
                this.peticion.cliente.direccion_instalacion = {};
            }
            if (this.peticion.cliente.direccion == null) {
                this.peticion.cliente.direccion = {};
            }
        },
        getProductosInteres() {
            axios.get(`api/get-productos-interes`).then(
                (res) => {
                    this.productos = res.data;
                },
                (res) => {}
            );
        },
        getConocidos() {
            axios.get(`api/get-cliente-conocido`).then(
                (res) => {
                    this.conocido = res.data;
                },
                (res) => {}
            );
        },
        getPeticion(id) {
            axios.get(`api/peticiones/${id}`).then((res) => {
                this.peticion = res.data;
                this.peticion.cliente.cuenta =
                    res.data.cliente.cuenta_contable.numero;
                if (this.peticion.cliente.direccion_instalacion == null) {
                    this.peticion.cliente.direccion_instalacion = {};
                }
                if (this.peticion.cliente.direccion == null) {
                    this.peticion.cliente.direccion = {};
                }
                //console.log(this.peticion.cliente);
            });
        },
        async savePeticion(id) {
            if (!this.$refs.form.validate()) {
                return null;
            }
            let id_cliente = this.peticion.id_cliente;
            if (this.peticion.cliente.id != null) {
                await this.updatecliente(this.peticion.cliente);
            } else {
                this.peticion.id_cliente = await this.savecliente(
                    this.peticion.cliente
                );
            }
            let url = `api/peticiones`;
            let res = null;
            if (id) {
                url += `/${id}`;
                res = await axios.put(url, this.peticion);
            } else {
                res = await axios.post(url, this.peticion);
            }

            this.peticion = res.data;
            this.$toast.sucs("Potencial guardado con éxito");
        },
        async updatecliente(cliente) {
            try {
                if (this.peticion.id_agente != null) {
                    const found_cliente = cliente.agentes.find(
                        (ele) => ele.id_agente == this.peticion.id_agente
                    );
                    console.log(
                        "agentes",
                        cliente.agentes,
                        this.peticion.id_agente
                    );
                    if (found_cliente == null) {
                        cliente.agentes.push({
                            id_agente: this.peticion.id_agente,
                        });
                    }
                }

                const res = await axios.post("api/update-cliente", cliente);
            } catch (error) {
                const message = error.response.data.mensaje;
                this.$custom_error(message);
            }
        },
        async savecliente(cliente) {
            try {
                if (cliente.id == null) {
                    cliente.conocido = this.peticion.conocido;
                    cliente.rol = 1;
                    if (this.peticion.id_agente != null) {
                        cliente.agentes = [
                            { id_agente: this.peticion.id_agente },
                        ];
                    }
                }
                const res = await axios.post("api/save-cliente", cliente);
                return res.data.id;
            } catch (err) {
                this.$toast.error(err.response.data.mensaje);
                throw err;
            }
        },
        getcliente(cliente_id) {
            axios.get(`api/getcliente/${cliente_id}`).then(
                (res) => {
                    this.peticion.id_cliente = res.data.id;
                    this.peticion.cliente = res.data;
                    if (this.peticion.cliente.direccion_instalacion == null) {
                        this.peticion.cliente.direccion_instalacion = {};
                    }
                    if (this.peticion.cliente.direccion == null) {
                        this.peticion.cliente.direccion = {};
                    }
                },
                (res) => {}
            );
        },
    },
    watch: {
        "peticion.id_cliente": function (val) {
            //this.getClientes(val);
        },
    },

    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        clientes() {
            let clientes_temp = this.$store.getters.getclientes;
            return clientes_temp;
        },
    },
};
</script>
